export const CLIENT_PREFILL_MIN_CHARS = 3

export function classifyClientPrefill(value) {
    const term = String(value || '').trim()

    if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(term)) return 'email'

    const digits = term.replace(/\D/g, '')
    const phoneLike = /^(?:\+|00)?[\d\s().-]+$/.test(term)
    const explicitCountryCode = /^(?:\+|00)/.test(term)
    const formattedPhone = /[\s().-]/.test(term)

    if (
        phoneLike &&
        digits.length >= 8 &&
        digits.length <= 15 &&
        (explicitCountryCode || formattedPhone || /^0\d{9}$/.test(digits))
    ) {
        return 'phone'
    }

    const company =
        /\b(?:SARL|SASU?|SCI|SA|ASSOCIATION|EURL|cr[eè]che|cabinet|agence)\b/i.test(term) ||
        /&/.test(term) ||
        /[a-z]\d|\d[a-z]/i.test(term) ||
        term.split(/\s+/).filter(Boolean).length >= 3

    if (company) return 'company'
    if (/^\d[\d\s]*$/.test(term) && digits.length >= 6) return 'identifier'

    return term.split(/\s+/).filter(Boolean).length > 1 ? 'fullName' : 'name'
}
